import React, {useEffect} from 'react';
import withStyles from '@mui/styles/withStyles';
import {Box, Typography} from '@mui/material';
import BackIcon from '@mui/icons-material/ArrowBack';
import {useHistory} from 'react-router-dom';
import { Padding } from '@mui/icons-material';

const BlackTextTypography = withStyles({
  root: {
    color: "#000000"
  }
})(Typography);

const styles = theme => ({
  heading: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#000',
    marginLeft: 20,
    textAlign: 'center',
  },
  body: {
    fontSize: 14,
    fontWeight: 100,
    color: '#000',
    marginTop: 10,
  },
  stepContainer: {
    marginTop: 20,
    marginLeft: 40,
  },
  step: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#000',
  },
  stepBody: {
    fontSize: 14,
    fontWeight: 200,
    color: '#000',
  },
  ruleImage: {
    height: 50,
  },
  submitButton: {
    marginTop: 40,
    fontSize: 16,
    pading: 20,
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#7FC5ED',
    width: '80%',
    borderRadius: 20,
  },
  backIcon: {
    zIndex: 200,
    position: 'absolute',
    left: 24,
    top: 40,
    color: '#fff',
  },
});

const FAQ = ({classes}) => {
  let history = useHistory();
  useEffect(() => {
    const wrapper = document.querySelector('.scrollable');
    if (!wrapper) return;

    document.querySelector('.scrollable').addEventListener(
      'touchmove',
      function(event) {
        event.stopPropagation();
      },
      false,
    );
  });

  return (
    <>
      <BackIcon className={classes.backIcon} onClick={history.goBack} />
      <div className="scrollable">
        <Box height="100%" className='profile-rules'>
          <Box display="flex">
            <Typography
              align="left"
              variant="body1"
              component="p"
              className={classes.heading}>
            FAQ-Bereich ApoCampus
            <br />
            Häufige Fragen
            </Typography>
          </Box>
          <BlackTextTypography
            align="left"
            variant="body1"
            component="p"
           >
            <ol className='profile-text-item'>
                <li><strong>Wie sammle ich Punkte?</strong></li>
                Unter deinen Kursen findest du alles rund um die Aposphäre-Schulung. Hier erwartet dich nicht nur eine Schulungszusammenfassung, sondern auch Praxistipps sowie diverse spielerische Möglichkeiten das Gelernte im Langzeitgedächtnis zu speichern oder das Ganze einfach noch einmal nachzulesen.Für jede durchgeführte Lektion erhältst du von uns Punkte.
                <br />
                <br />
                <li><strong>Wie viele Punkte kann ich sammeln?</strong></li>
                Das Sammelfieber hat dich gepackt? Das Schöne ist: Es gibt keine Maximalpunktzahl! Führe Lektionen durch und spare auf deinen Wunsch-Coupon oder löse mehrere Coupons gleichzeitig ein!Du hast bereits alle Lektionen durchgeführt? Wende dich für eine neue Schulung an deine Aposphäre-Trainerin!
                <br />
                <br />
                <li><strong>Wo kann ich meine Punkte einlösen?</strong></li>
                Punkte sammeln muss belohnt werden! Wie? Ganz einfach: 1. Wähle die Kategorie „Punkte“ aus; 2. Unter „Punkte einlösen“ kannst du gewünschte Coupons mit deinen Punkten shoppen.
                <br />
                <br />
                <li><strong>Wie kann ich meine Coupons einlösen?</strong></li>
                Mit deinen gesammelten Punkten hast du dir deinen Wunsch-Coupon ausgesucht?Dann kannst du ihn nun unter „Meine Coupons“ aufrufen und einlösen. Die App führt dich durch die Einlösungsschritte - entweder über das direkte Abscannen des Coupons und euer Kassensystem mit KyteTec oder über ein Cashback-Formular.Folge dem Link für ein Tutorial.
                <br />
                <br />
                <li><strong>Das Kassensystem scannt meinen Coupon nicht – wo melde ich mich?</strong></li>
                Damit du auch bei technischen Herausforderungen von deinen gesammelten Punkten profitieren kannst, wende dich an support@aposphaere.de
                <br />
                <br />
                <li><strong>Wo finde ich meine Schulungs-Zertifikate?</strong></li>
                n der Kategorie „Punkte“ findest du diese unter „Meine Zertifikate“. Hier werden alle Zertifikate deiner künftigen Aposphäre-Schulungen gesammelt. Deine Zertifikatssammlung kann von überall abgerufen und jederzeit bei Bedarf ausgedruckt werden. „Meine Zertifikate“ dienst also als dein digitaler Sammelordner - praktisch und umweltfreundlich!
                <br />
                <br />
                <li><strong>Warum werden mir meine Schulungszertifikate nicht angezeigt?</strong></li>
                Wenn du während der Aposphäre-Schulung keine oder eine andere E-Mail-Adresse angegeben hast als im aposphäre campus, kann die App deine Zertifikate nicht korrekt zuordnen.
                <br />
                <br />
                <li><strong>Wie können sich meine neuen Kollegen und Kolleginnen anmelden?</strong></li>
                Auch neue Kollegen oder Kolleginnen, die am Schulungstag nicht anwesend waren, können sich im Nachgang beim aposphäre campus anmelden. Sie erhalten alle Inhalte bisher geschulter Themen, können Punkte sammeln und profitieren so ebenfalls. Ganz einfach: 1. App runterladen; 2. Registrieren; 3. Anmelden und Spaß haben!Für die Registrierung zur Anmeldung ist der Registrierungscode für eure Apotheke für alle Kollegen und Kolleginnen derselbe. Registrierungscode vergessen? Wende dich gerne an deinen Aposphäre-Trainer oder an support@aposphäre.de
                <br />
                <br />
                <li><strong>Ich wechsle die Apotheke – wo melde ich mich?</strong></li>
                Um dir immer korrekt deine Zertifikate und Schulungslektionen technisch zuzuordnen, ist es notwendig dich der entsprechenden Apotheke zuzuordnen. Wende dich dafür an: support@aposphaere.de
                <br />
                <br />
                <li><strong>An wen wende ich mich bei technischen Problemen?</strong></li>
                Meistens hilft es bereits die App vollständig zu schließen und neu zu öffnen. Sollte diese Maßnahme nicht funktionieren, wende dich gerne an support@aposphaere.de.
            </ol>
          </BlackTextTypography>
        </Box>
      </div>
    </>
  );
};

export default withStyles(styles)(FAQ);
